import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import "../styleSheets/testimonials.css";
import "../styleSheets/buttons.css";
import ArrowRight from "../images/arrow-right.svg";
import ArrowLeft from "../images/arrow-left.svg";
import { useTestimonials } from "../utilities/testimonials";

const CustomerTestimonials = () => {
  const [page, setPage] = useState(0);
  const { t, i18n } = useTranslation("common");
  const { status, testimonials } = useTestimonials(
    i18n.resolvedLanguage ?? i18n.language,
  );

  const itemsPerPage = 3;

  const activeTestimonials = useMemo(
    () => testimonials.filter((testimonial) => testimonial.Active === true),
    [testimonials],
  );

  const startIndex = page * itemsPerPage;
  const currentTestimonials = activeTestimonials.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  const nextPage = () => setPage((p) => p + 1);
  const prevPage = () => setPage((p) => Math.max(0, p - 1));

  return (
    <section className="section-testimonials" aria-labelledby="testimonials-title">
      <div className="container-testimonials">
        <div className="title-area">
          <h2 id="testimonials-title" className="title-text">
            {t("pageBody.testimonial.testimonialsTitle", { ns: "common" })}
          </h2>
          <div className="divider" />
        </div>
        {status === "loading" ? (
          <div>{t("loading", { ns: "common" })}</div>
        ) : status === "unavailable" ? (
          <div role="alert">{t("errorMessage.failedLoad", { ns: "common" })}</div>
        ) : activeTestimonials.length === 0 ? (
          <div>{t("pageBody.testimonial.noTestimonials", { ns: "common" })}</div>
        ) : (
          <div className="testimonials-card-section">
            <button
              type="button"
              className="btn btn--circle btn--circle-orange"
              onClick={prevPage}
              disabled={page === 0}
              aria-label={t("pageBody.testimonial.prevTestimonials", {
                ns: "common",
              })}
            >
              <img src={ArrowLeft} alt="" className="arrow-icon-left" />
            </button>

            {currentTestimonials.map((testimonial, index) => (
              <div
                className="card-testimonial"
                key={testimonial.id ?? `${startIndex + index}-${testimonial.Name}`}
              >
                <div className="name-city-container">
                  <div className="name-city-section">
                    <div className="name">
                      {testimonial.Name}
                    </div>
                    <div className="city">
                      {testimonial.Location ? ` (${testimonial.Location})` : ""}
                    </div>
                  </div>
                </div>
                <div className="comment">"{testimonial.Comment}"</div>
              </div>
            ))}

            <button
              type="button"
              className="btn btn--circle btn--circle-orange"
              onClick={nextPage}
              disabled={startIndex + itemsPerPage >= activeTestimonials.length}
              aria-label={t("pageBody.testimonial.nextTestimonials", {
                ns: "common",
              })}
            >
              <img src={ArrowRight} alt="" className="arrow-icon-right" />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default CustomerTestimonials;
